export default __webpack_public_path__ + "static/media/airstrapz-blk-banner-1.37ad6a47.jpg";